(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wildcraft-banners"] && !Shopify.designMode) return;
  try {
    
function initWildcraftBanners(root) {
  root.querySelectorAll('.wc-banners').forEach(section => {
    if (section.dataset.wcReady) return;
    section.dataset.wcReady = 'true';
    const track = section.querySelector('.wc-banners__track');
    const slides = [...track.children];
    const buttons = [...section.querySelectorAll('[data-wc-index]')];
    buttons.forEach((button, i) => button.addEventListener('click', () => {
      track.scrollTo({left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        buttons.forEach((button, n) => n === i ? button.setAttribute('aria-current','true') : button.removeAttribute('aria-current'));
        ticking = false;
      });
    }, {passive:true});
  });
}
initWildcraftBanners(document);
document.addEventListener('shopify:section:load', e => initWildcraftBanners(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wildcraft-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('a[href="#wildcraft-delivery"]');if(link){const details=document.getElementById('wildcraft-delivery');if(details)details.open=true;}});

  } catch(e) { console.error(e); }
})();
})();
